import { IVariantType } from '../../../types';

export const VARIANT_BADGE_CONFIG: Record<
  IVariantType,
  { variant: 'A' | 'B'; tone?: 'active'; labelKey: string }
> = {
  [IVariantType.VARIANT_A]: { variant: 'A', tone: 'active', labelKey: 'Control' },
  [IVariantType.VARIANT_B]: { variant: 'B', labelKey: 'Variant' },
};

export const MOBILE_VARIANT_GRADIENT_BG: React.CSSProperties = {
  background:
    'linear-gradient(to bottom, rgba(44,125,255,0.06) 0%, rgba(44,125,255,0.04) 45%, rgba(243,74,112,0.04) 55%, rgba(243,74,112,0.06) 100%)',
};

export const MOBILE_VARIANT_CARD_MIN_HEIGHT_PX = 148;
